/**
 * Длительности и кривые для motion (из mrbooker, client/src/motion/config.ts).
 * Больше 300 мс интерфейс начинает казаться медленным — потолок здесь. CSS-переходы — --press-duration / --ease-out-ui (newdesign.css).
 */
export const DURATION = {
  fast: 0.22,
  base: 0.26,
} as const;

/** Кривая появления: быстрый разгон, мягкое торможение (= --ease-out-ui). */
export const EASE_OUT: [number, number, number, number] = [0.22, 1, 0.36, 1];

/** Мягкая пружина — для переезда подложки выбранной вкладки: не дребезжит. */
export const SPRING_SOFT = { type: 'spring', stiffness: 300, damping: 32 } as const;
